// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3MkWj","upload":"Small_upload__aIYS1","imageWrap":"Small_imageWrap__3uqgG","removeBtn":"Small_removeBtn__irsHy"};